
export default {
  data() {
    return {
      isDark: false,
    };
  },
  computed: {
    theme() {
      return this.$store.state.theme.name;
    },
  },
  mounted() {
    this.isDark = this.$store.state.theme.name === "dark";
    this.console();
  },
  methods: {
    console() {
      this.$log.debug(this.isDark);
    },
    changeTheme() {
      this.$store.commit("theme/toggle", this.isDark ? "dark" : "light");
      this.console();
    },
  },
};
